<script setup lang="ts">
import type { AppFilterChipEntry } from "@carnet/ui/utils/filterChips";

defineProps<{ chips: AppFilterChipEntry[] }>();
const emit = defineEmits<{ remove: [key: string, value?: string] }>();
</script>

<template>
  <template v-for="chip in chips" :key="`${chip.key}-${chip.value ?? ''}`">
    <AppFilterRadioChip v-if="!chip.removable" :label="chip.label" />
    <AppFilterChip v-else :label="chip.label" @remove="emit('remove', chip.key, chip.value)" />
  </template>
</template>
